<div class="overlap_panel_wrapper">
  <div class="overlap_panel_sidebar">
    <div class="side_header">
      <div class="cross_wrap">
        <a href="javascript:void(0);" (click)="close('')">
          <img src="../../../../assets/img/cross_icon.svg" alt="" class="icon">
        </a>
      </div>
      <p class="company_name">Warehouse Name</p>
      <div class="back_wrap">
        @if (stepper.selectedIndex > 0) {
          <a (click)="goBack(stepper)" class="back-button">
            <img src="../../../../assets/img/left_orange_arrow.svg" alt="Back" class="arrow">
            <span>Back</span>
          </a>
        }
      </div>
    </div>
    <div class="sidebar_accordion">
      @if (warehouseForm?.get('step01')?.get('wareHouse')) {
        <app-warehouse-step-preview [model]="model" [step]="step" [form]="warehouseForm"></app-warehouse-step-preview>
      }
    </div>
  </div>
  <div class="warehouse-overlap-panel-wrapper overlap_right_panel">
    <form [formGroup]="warehouseForm"  novalidate>
      <mat-horizontal-stepper #stepper [linear]="true" (selectionChange)="onStepChanged($event, stepper)">
        <mat-step formGroupName="step01"  [stepControl]="warehouseForm.get('step01')!">
          <ng-template matStepLabel>Warehouse Name</ng-template>
          <app-warehouse-name  formControlName="wareHouse" [form]="warehouseForm" [model]="model" (onInitForm)="initChildForm('step01', 'wareHouse',$event.value)"></app-warehouse-name>
          <div class="controls">
            <button mat-button class="btn_transparent" (click)="close('')">Cancel</button>
            <button type="button" mat-button matStepperNext (click)="touchFormControls('step01')" class="btn_solid_color">Next  <img src="../../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
          </div>

        </mat-step>
        <mat-step formGroupName="step02" [stepControl]="warehouseForm.get('step02')!">
          <ng-template matStepLabel>Warehouse Detail</ng-template>
          <app-warehouse-address-detail  formControlName="wareHouseDetail" [form]="warehouseForm.get('step02')" [model]="model" (onInitForm)="initChildForm('step01', 'wareHouseDetail',$event.value)"></app-warehouse-address-detail>
          <div class="controls">
            <button mat-button matStepperPrevious class="btn_transparent">Back</button>
            <button type="button" mat-button    (click)="finalPreviewFn(stepper)" class="btn_solid_color">Review  <img src="../../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
          </div>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>Preview</ng-template>
          @if (this.step?.event?.selectedIndex === 2) {
            <app-warehouse-final-preview [model]="model"  [form]="warehouseForm"></app-warehouse-final-preview>
          }
          <div class="controls">
            <button mat-button matStepperPrevious (click)="cancelPreview()" class="btn_transparent">Back</button>
            <button type="button" mat-button class="btn_solid_color" (click)="onSubmit()" [disabled]="isSubmitting">
              @if (isSubmitting) {
                {{ id ? 'Updating…' : 'Creating…' }}
                <span class="btn-spinner" aria-hidden="true"></span>
              } @else {
                {{ id ? 'Update' : 'Create' }}
                <img src="../../../../../assets/img/btn_arrow.png" alt="icon" class="icon">
              }
            </button>
          </div>

        </mat-step>
      </mat-horizontal-stepper>
    </form>
  </div>
</div>

